module.exports = __webpack_public_path__ + "img/Airbnb-Office-Everyday-Stretches-Back-Twist.ec7c556f.jpg";